/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp.  2014, 2018
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'../../lib/@waca/core-client/js/core-client/ui/dialogs/BaseDialog',
	'jquery',
	'underscore'
], function(BaseDialog, $, _) {

	var Dialog = null;
	Dialog = BaseDialog.extend({

		_buttons: ['ok'],

		init: function(sType, sTitle, sMessage) {
			this._props = {
				'type': sType,
				'title': sTitle,
				'msg': sMessage
			};
			Dialog.inherited('init', this, [this._props]);
		},

		renderContent: function(n) {
			n.append(
				$('<div>', {
					'class': 'dashboardMessageBox ' + this._props.type,
					'html': _.escape(this._props.msg)
				})
			);
			return n;
		},

		renderTitle: function(n) {
			n.text(this._props.title);
			return n;
		}

	});

	return Dialog;
});
